import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getEmailTemplateFormInputs } from "../model/email-template.modal";
import { menuUrl } from "../email-template-list/model/email-template-list.constants";
import { createEmailTemplateApi } from "./email-template-create.component.service";
import EmailTemplateCreateTemplateComponent from "./email-template-create-template.component";
import { uploadTemplate } from "../email-template-list/email-template-list.component.service";
import { BASE_URL } from "@constants/api.constants";
const {
  ALERT_TYPES: { SUCCESS, ERROR },
  EMAIL_TEMPLATE_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const EmailTemplateCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleEmailTemplateSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct email template payload
    let emailTemplatePayload = {};
    for (let i = 0; i < values.length; i++) {
      emailTemplatePayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const emailTemplateResponse = await createEmailTemplateApi(
      emailTemplatePayload
    );

    // INFO : check api response and show relevant alert message
    if (emailTemplateResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: emailTemplateResponse.message })
      );
    }
  };

  const handleFileUpload = async ({ file, index, formInputs }) => {
    // console.log({ file, index, formInputs });
    let copyFormInputs = [...formInputs];
    copyFormInputs[index].loading = true;
    setInitialFormInputs(copyFormInputs);

    const uploadTemplateResponse = await uploadTemplate(file[0]);
    // console.log({ uploadTemplateResponse });
    if (uploadTemplateResponse.status) {
      let copyFormInputs2 = [...copyFormInputs];
      const uploadedFile = {
        name: file[0].name,
        file:
          BASE_URL +
          "app-source/email-templates/" +
          uploadTemplateResponse.data,
      };
      copyFormInputs2[index].loading = false;
      copyFormInputs2[index].value = copyFormInputs2[index].multipleUpload
        ? [...copyFormInputs2[index].value, uploadedFile]
        : uploadedFile.file;
      copyFormInputs2[index].loading = false;
      setInitialFormInputs(copyFormInputs2);
    } else {
      let copyFormInputs3 = [...copyFormInputs];
      copyFormInputs3[index].loading = false;
      setInitialFormInputs(copyFormInputs3);
      alert("Invalid File Format");
    }
  };

  const [initialFormInputs, setInitialFormInputs] = useState(
    getEmailTemplateFormInputs({
      handleFileUpload,
    })
  );
  const templateModal = {
    formTriggers,
    formInputs: initialFormInputs,
  };

  const templateEvents = {
    handleEmailTemplateSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <EmailTemplateCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default EmailTemplateCreateComponent;
